import { gql as oldGql } from '@apollo/client';
import { gql } from '__generated__';
import client from 'graphql/client';

const fetchAvailableJobsForUpsale = () => {
  const query = oldGql`
    query availableJobsForUpsale {
      availableJobsForUpsale {
        id
        title
        status
        datePosted
        expireDate
        jobSmartSort {
			    enabled
		    }
      }
      lists {
        cities {
          id
          name
        }
        countries {
          id
          name
        }
        jobBenefits {
          id
          name
        }
      }
    }
  `;

  return client.query({
    query,
    fetchPolicy: 'network-only',
  });
};

const fetchJobDataForUpsale = (jobId: number) => {
  const query = oldGql`
    query fetchJobDataForUpsale($jobId: Int) {
      job(id: $jobId) {
        id
        title
        jobType
        siteVisibility
        duration
        daysLeftTillExpiration
        daysPassedAfterPublication
        datePosted
        expireDate
        highlighted
        topResult
        jobSmartSort {
					enabled
				}
        jobSocialPosting {
          postingSite
          socialNetwork
        }
        benefits {
          id
          benefitId
          text
        }
      }
    }
  `;

  const variables = {
    jobId,
  };

  return client.query({
    query,
    variables,
    fetchPolicy: 'no-cache',
  });
};

export const INSERT_UPSALE_QUERY = gql(`
  mutation insertUpsale(
    $jobId: Int!
    $socialPosting: [SocialPostingInput]
    $highlighted: Int
    $topResult: Boolean
    $topResultActivationDate: String
    $benefits: [Int]
    $smartSort: Boolean
    $paymentMethod: PaymentMethod!
    $billingContactName: String
    $billingCompanyName: String
    $pib: String
    $phone: String
    $zipCode: String
    $address: String
    $idNumber: String
    $cardOwnerName: String
    $countryId: Int
    $cityId: Int
    $cityName: String
    $employerType: Int
  ) {
    insertUpsale(
      jobId: $jobId
      upsale: {
        socialPosting: $socialPosting
        highlighted: $highlighted
        topResult: $topResult
        topResultActivationDate: $topResultActivationDate
        benefits: $benefits
        paymentMethod: $paymentMethod
        smartSort: $smartSort
      }
      paymentDetails: {
        contactName: $billingContactName
        companyName: $billingCompanyName
        pib: $pib
        phone: $phone
        zipCode: $zipCode
        address: $address
        idNumber: $idNumber
        cardOwnerName: $cardOwnerName
        countryId: $countryId
        cityId: $cityId
        cityName: $cityName
        employerType: $employerType
      }
    ) {
      id
      paymentMethod
    }
  }
`);

const insertUpsale = (variables: any) => {
  const mutation = INSERT_UPSALE_QUERY;

  return client.mutate({
    mutation,
    variables,
  });
};

const GET_AVAILABLE_UPSALE_OPTIONS_FOR_JOB = gql(`
 query availableUpsaleOptionsForJob($jobId: Int!){
    availableUpsaleOptionsForJob(jobId: $jobId) {
        upsaleOptions 
        daysTillJobExpires
    }
} `);

const fetchAvailableUpsaleOptionsForJob = (jobId: number) => {
  return client.query({
    query: GET_AVAILABLE_UPSALE_OPTIONS_FOR_JOB,
    variables: { jobId },
    fetchPolicy: 'no-cache',
  });
} 


export default fetchAvailableJobsForUpsale;
export { fetchJobDataForUpsale, insertUpsale, fetchAvailableUpsaleOptionsForJob };
